import {baseApi} from "../baseApi";
import {ICreateFeedback, IFeedbackResponse, IGetFeedbacksFilter} from "./types";

const endpoints = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getFeedbacks: builder.query<IFeedbackResponse, IGetFeedbacksFilter>({
            query: (params) => ({
                url: `api/adm/feedbacks`,
                method: 'GET',
                params:{...params}
            }),
            providesTags: ['feedback']

        }),
        createFeedbacks: builder.mutation<any, ICreateFeedback>({
            query: ({id,body}) => ({
                url: `api/adm/feedbacks/${id}`,
                method: 'POST',
                body:{...body}
            }),
            invalidatesTags: ['feedback']

        }),

    })
})

export const {
    useLazyGetFeedbacksQuery,
    useCreateFeedbacksMutation
} = endpoints